import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import './Slider.scss';
export function SliderFactory({ as, value, min, max, step, marks, showValue, isDisabled, valueFormatter, onChange, }) {
    const handleChange = useCallback((e) => {
        const newValue = parseFloat(e.target.value);
        onChange(e, { value: newValue });
    }, [onChange]);
    const formattedValue = valueFormatter?.(value) ?? value;
    const marksArray = useMemo(() => (marks ? Object.entries(marks) : undefined), [marks]);
    return (_jsx("div", { className: classNames({ 'sg-slider': true, 'sg-slider-opacity': as === 'OpacitySlider' }), 
        // @ts-ignore
        style: { '--SG_SLIDER_VALUE': value }, children: _jsxs("div", { className: 'sg-slider--inner', children: [_jsx("input", { className: 'sg-slider--input', type: 'range', value: value, min: min, max: max, step: step, disabled: isDisabled, onChange: handleChange }), showValue !== false && _jsx("output", { className: 'sg-slider--value', children: formattedValue }), marksArray && (_jsx("div", { className: 'sg-slider--marks', 
                    // @ts-ignore
                    style: { '--SG_SLIDER_MARKS_COUNT': marksArray.length }, children: marksArray.map(([value, label]) => (_jsx("span", { className: 'sg-slider--mark', children: label }, value))) }))] }) }));
}
//# sourceMappingURL=SliderFactory.js.map